import { render, staticRenderFns } from "./TransferBytesToWalletModal.vue?vue&type=template&id=121e90a6&scoped=true&"
import script from "./TransferBytesToWalletModal.vue?vue&type=script&lang=js&"
export * from "./TransferBytesToWalletModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121e90a6",
  null
  
)

export default component.exports